import { Component, ElementRef, inject, input, output, signal, viewChild, effect } from '@angular/core';
import { asapScheduler } from "rxjs";
import { ActivityTrackingService } from '../services/activity-tracking.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RelatedEntity } from '../models/classes/related-entity.class';
import { InvestorPortfolioSeriesReportingDealBreadcrumb } from '../models/classes/investor-portfolio-series-reporting-deal-breadcrumb.class';
import { EnvironmentVariablesService } from '../services/environment-variables.service';

@Component({
    selector: 'app-auto-adjusting-dropdown',
    imports: [CommonModule, FormsModule],
    templateUrl: './auto-adjusting-dropdown.component.html',
    styleUrls: ['./auto-adjusting-dropdown.component.scss']
})
export class AutoAdjustingDropdownComponent {
  private activityTracking = inject(ActivityTrackingService);
  private evService = inject(EnvironmentVariablesService);

  readonly selectedEl = viewChild<ElementRef>('hiddenSelected');
  readonly selectEl = viewChild<ElementRef>('selectList');
  readonly selected = input<string>('');
  readonly dataForBreadcrumbs = input<RelatedEntity[] | InvestorPortfolioSeriesReportingDealBreadcrumb[] | undefined>(undefined);
  readonly selectedValue = input<unknown>('');
  readonly updateWidth = input<boolean>(false);
  readonly valueProperty = input<string | undefined>(undefined);
  readonly nameProperty = input<string | undefined>(undefined);
  readonly groupProperty = input<string | undefined>(undefined);
  readonly outerdivClass = input<string>('');
  readonly optionClass = input<string>('');
  readonly showOneOptGroup = input<boolean>(false);
  readonly optionClassProperty = input<string | undefined>(undefined);
  readonly selectClass = input<string | undefined>(undefined);
  readonly type = input<string | undefined>(undefined);
  readonly goToSelected = output<string>();
  width = signal(300);
  showCommingledExperience: boolean = this.evService.showCommingledExperience;

  private readonly updateWidthOnSelectedChange = effect(() => {
    const selected = this.selected();
    const hiddenEl = this.selectedEl()?.nativeElement;
    if (selected && hiddenEl) {
      asapScheduler.schedule(() => {
        hiddenEl.innerHTML = selected;
        this.getWidth();
      });
    }
  });

  getWidth() {
    asapScheduler.schedule(() => {
      this.width.set((this.selectedEl() as ElementRef).nativeElement.clientWidth + 20);
    });
  }

  setHiddenBreadcrumbAndUpdateWidth() {
    asapScheduler.schedule(() => {
      const text = (this.selectEl() as ElementRef).nativeElement.options[(this.selectEl() as ElementRef).nativeElement.selectedIndex]?.innerHTML;
      if(!text) return;
      (this.selectedEl() as ElementRef).nativeElement.innerHTML = text;
      this.getWidth();
    })
  }

  sendSelected(event: Event): void {
    const el = event.target as HTMLSelectElement;
    const activity: { name: string; contextParameter?: Record<string, string>[] } = {
      name: `${this.type()} dropdown`,
      contextParameter: [{'type': this.type() ?? ''}, {'id': el.value}, {'name': el.options[el.selectedIndex].text}]
    }
    this.activityTracking.userActivityStorage(activity);
    this.setHiddenBreadcrumbAndUpdateWidth();
    this.goToSelected.emit(el.value);
  }
}

